(function() {
  var DEFAULTS = { 'tablet': 768, 'tabletlandscape': 1024, 'desktop': 1200, 'fullsize': 1400 };
  var getBreakpoint = function(point, mod = 0) {
    var value = getComputedStyle(document.documentElement).getPropertyValue('--js-breakpoint-' + point);
    var valParts = /([0-9.]+)(.+)/.exec(value);
    if(valParts) {
      return (parseFloat(valParts[1]) + mod) + valParts[2];
    } else if(DEFAULTS[point]) {
      return (DEFAULTS[point] + mod) + 'px';
    } else {
      return (768 + mod) + 'px';
    }
  }

  var BRK_MOBILEONLY = '(max-width: ' + getBreakpoint('tablet', -1) + ')';
  var BRK_TABLET = '(min-width: ' + getBreakpoint('tablet') + ')';
  var BRK_TABLETLANDSCAPE = '(min-width: ' + getBreakpoint('tabletlandscape') + ')';
  var BRK_DESKTOP = '(min-width: ' + getBreakpoint('desktop') + ')';
  var BRK_FULLSIZE = '(min-width: ' + getBreakpoint('fullsize') + ')';

  if(window.matchMedia) {
    var MQ_MOBILEONLY = window.matchMedia(BRK_MOBILEONLY);
    var MQ_TABLET = window.matchMedia(BRK_TABLET);
    var MQ_TABLETLANDSCAPE = window.matchMedia(BRK_TABLETLANDSCAPE);
    var MQ_DESKTOP = window.matchMedia(BRK_DESKTOP);
    var MQ_FULLSIZE = window.matchMedia(BRK_FULLSIZE);

    /**
      * Event Functions
      */
    function handleBreakpointChange() {
      window.currentBreakpoint = [];
      var dispatchEvents = [];
      var width = window.innerWidth;
      if(MQ_MOBILEONLY.matches) {
        window.currentBreakpoint.push('mobile');
        dispatchEvents.push(new CustomEvent('breakpoint-mobile', { detail: width }));
      }
      if(MQ_TABLET.matches) {
        window.currentBreakpoint.push('tablet');
        dispatchEvents.push(new CustomEvent('breakpoint-tablet', { detail: width }));
      }
      if(MQ_TABLETLANDSCAPE.matches) {
        window.currentBreakpoint.push('tabletlandscape');
        dispatchEvents.push(new CustomEvent('breakpoint-tabletlandscape', { detail: width }));
      }
      if(MQ_DESKTOP.matches) {
        window.currentBreakpoint.push('desktop');
        dispatchEvents.push(new CustomEvent('breakpoint-desktop', { detail: width }));
      }
      if(MQ_FULLSIZE.matches) {
        window.currentBreakpoint.push('fullsize');
        dispatchEvents.push(new CustomEvent('breakpoint-fullsize', { detail: width }));
      }
      dispatchEvents.forEach(function(event) {
        window.dispatchEvent(event);
      });
    }

    MQ_MOBILEONLY.addListener(handleBreakpointChange);
    // Don't need to add this one, since it's handled by the mobile breakpoint event handler
    // The handler fires when the media query no longer matches, so it will fire
    // when tablet becomes active too.
    // MQ_TABLET.addListener(handleBreakpointChange);
    MQ_TABLETLANDSCAPE.addListener(handleBreakpointChange);
    MQ_DESKTOP.addListener(handleBreakpointChange);
    MQ_FULLSIZE.addListener(handleBreakpointChange);
    handleBreakpointChange();
  }
})();